import {createAction} from 'typesafe-actions';

import type {SortKey} from '../../../util/queryTypes';
import type * as Types from './types';

export const set = createAction(
  '@view/sort/set',
  action => (ref: Types.Ref, sort: Types.Sort) => action({ref, sort})
);

export const upsert = createAction(
  '@view/sort/upsert',
  action => (ref: Types.Ref, sortKey: SortKey) => action({ref, sortKey})
);

export type ActionType = ReturnType<typeof set>;
